var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.dialog,
        title: "导入Excel",
        width: _vm.getIsMobile ? "100%" : "60%",
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "before-close": _vm.handleClose,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialog = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.upLoading,
              expression: "upLoading",
            },
          ],
          ref: "uploadInfoRef",
          attrs: {
            "label-width": "100px",
            "label-position": "right",
            rules: _vm.rules,
            model: _vm.uploadInfo,
          },
        },
        [
          _c("div", { staticClass: "marginbottom" }, [
            _vm._v(
              "为减少上传错误，请下载案件导入模版后按照模版格式要求进行数据填写后再上传!"
            ),
          ]),
          _c(
            "el-link",
            {
              staticClass: "marginbottom",
              attrs: { type: "primary", icon: "el-icon-download" },
            },
            [
              _c(
                "a",
                { attrs: { target: "_blank" }, on: { click: _vm.handleDown } },
                [_vm._v("下载导入模板")]
              ),
            ]
          ),
          _c(
            "el-form-item",
            { attrs: { label: "价格表" } },
            [
              _c(
                "el-select",
                {
                  ref: "selectRef",
                  staticClass: "model-select",
                  attrs: {
                    filterable: "",
                    remote: "",
                    "popper-append-to-body": "",
                    "reserve-keyword": "",
                    "automatic-dropdown": true,
                    "default-first-option": true,
                    placeholder: "请选择价格表",
                    "remote-method": _vm.priceRemoteMethod,
                    clearable: "",
                    loading: _vm.priceLoading,
                  },
                  on: { change: _vm.handleChangePrice },
                  model: {
                    value: _vm.uploadInfo.price_version,
                    callback: function ($$v) {
                      _vm.$set(_vm.uploadInfo, "price_version", $$v)
                    },
                    expression: "uploadInfo.price_version",
                  },
                },
                _vm._l(_vm.priceOptions, function (item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _vm.type === "edit"
            ? _c(
                "el-form-item",
                { attrs: { label: "原币价格", prop: "price" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入原币价格" },
                    model: {
                      value: _vm.uploadInfo.price,
                      callback: function ($$v) {
                        _vm.$set(_vm.uploadInfo, "price", $$v)
                      },
                      expression: "uploadInfo.price",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-form-item",
            { attrs: { label: "原币种", prop: "currency" } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    placeholder: "请选择原币种",
                    filterable: "",
                    clearable: "",
                  },
                  model: {
                    value: _vm.uploadInfo.currency,
                    callback: function ($$v) {
                      _vm.$set(_vm.uploadInfo, "currency", $$v)
                    },
                    expression: "uploadInfo.currency",
                  },
                },
                _vm._l(_vm.allRate, function (item, index) {
                  return _c(
                    "el-option",
                    {
                      key: index,
                      attrs: {
                        label: item.currency_name,
                        value: item.currency,
                      },
                    },
                    [
                      _c("span", { staticStyle: { float: "left" } }, [
                        _vm._v(_vm._s(item.currency_name)),
                      ]),
                      _c(
                        "span",
                        {
                          staticStyle: {
                            float: "right",
                            color: "#8492a6",
                            "font-size": "13px",
                          },
                        },
                        [_vm._v(_vm._s(item.rate))]
                      ),
                    ]
                  )
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "成本系数" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入成本系数" },
                model: {
                  value: _vm.uploadInfo.cost_coefficient,
                  callback: function ($$v) {
                    _vm.$set(_vm.uploadInfo, "cost_coefficient", $$v)
                  },
                  expression: "uploadInfo.cost_coefficient",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "销售系数" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入销售系数" },
                model: {
                  value: _vm.uploadInfo.selling_coefficient,
                  callback: function ($$v) {
                    _vm.$set(_vm.uploadInfo, "selling_coefficient", $$v)
                  },
                  expression: "uploadInfo.selling_coefficient",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "供应商", prop: "gongyingshang" } },
            [
              _c(
                "el-select",
                {
                  ref: "selectRef",
                  staticClass: "model-select",
                  attrs: {
                    filterable: "",
                    remote: "",
                    "popper-append-to-body": "",
                    "reserve-keyword": "",
                    "automatic-dropdown": true,
                    "default-first-option": true,
                    placeholder: "请选择供应商",
                    "remote-method": _vm.remoteMethod,
                    clearable: "",
                    loading: _vm.loading,
                  },
                  on: { change: _vm.handleChange },
                  model: {
                    value: _vm.uploadInfo.gongyingshang,
                    callback: function ($$v) {
                      _vm.$set(_vm.uploadInfo, "gongyingshang", $$v)
                    },
                    expression: "uploadInfo.gongyingshang",
                  },
                },
                _vm._l(_vm.options, function (item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "库存版本", prop: "version" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入库存版本" },
                model: {
                  value: _vm.uploadInfo.version,
                  callback: function ($$v) {
                    _vm.$set(_vm.uploadInfo, "version", $$v)
                  },
                  expression: "uploadInfo.version",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "货期", prop: "hq" } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    "allow-create": "",
                    filterable: "",
                    "default-first-option": "",
                    placeholder: "请选择货期，或手动输入",
                    clearable: "",
                  },
                  model: {
                    value: _vm.uploadInfo.hq,
                    callback: function ($$v) {
                      _vm.$set(_vm.uploadInfo, "hq", $$v)
                    },
                    expression: "uploadInfo.hq",
                  },
                },
                _vm._l(_vm.hqData, function (item, index) {
                  return _c(
                    "el-option",
                    { key: index, attrs: { value: item, label: item } },
                    [_vm._v(" " + _vm._s(item) + " ")]
                  )
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "备注", prop: "bz" } },
            [
              _c("el-input", {
                attrs: {
                  type: "textarea",
                  placeholder: "请输入备注",
                  autosize: "",
                },
                model: {
                  value: _vm.uploadInfo.bz,
                  callback: function ($$v) {
                    _vm.$set(_vm.uploadInfo, "bz", $$v)
                  },
                  expression: "uploadInfo.bz",
                },
              }),
            ],
            1
          ),
          _vm.type === "add"
            ? _c(
                "el-form-item",
                { attrs: { label: "文件上传" } },
                [
                  _c(
                    "el-upload",
                    {
                      ref: "upload",
                      attrs: {
                        multiple: false,
                        limit: 1,
                        accept: ".xlsx, .xls",
                        action: _vm.action,
                        drag: "",
                        data: Object.assign({}, _vm.uploadInfo),
                        "show-file-list": true,
                        "auto-upload": false,
                        "on-change": _vm.handleChangeUpload,
                        "on-success": _vm.uploadSuc,
                        "on-error": _vm.uploadFail,
                        "on-remove": _vm.cancelExcel,
                        "before-upload": _vm.beforeUpload,
                        "file-list": _vm.fileList,
                      },
                    },
                    [
                      _c("i", { staticClass: "el-icon-upload" }),
                      _c("div", { staticClass: "el-upload__text" }, [
                        _vm._v("将文件拖到此处，或"),
                        _c("em", [_vm._v("点击上传")]),
                      ]),
                      _c(
                        "div",
                        {
                          staticClass: "el-upload__tip",
                          staticStyle: { color: "red", width: "max-content" },
                          attrs: { slot: "tip" },
                          slot: "tip",
                        },
                        [_vm._v(" 提示：仅允许导入“xls”或“xlsx”格式文件！ ")]
                      ),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c("el-button", { on: { click: _vm.handleClose } }, [
            _vm._v("取 消"),
          ]),
          _c(
            "el-button",
            {
              attrs: { type: "primary", loading: _vm.submitLoading },
              on: { click: _vm.handleSubmit },
            },
            [_vm._v("确 定")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }